<template>
    <div id="app">
        <v-app>
            <v-content style="background-color: #6b2de3;position: fixed;z-index: 2">
                <v-layout style="width: 100%;height: 100%;z-index: 3">A</v-layout>
            </v-content>
            <Footer></Footer>
        </v-app>
    </div>
</template>

<script>
    import Footer from "../components/Footer"
    export default {
        name: "test",
        components: {
            Footer,
        },
    }
</script>

<style scoped>

</style>
